<div>
  <!-- Barra de resumen de 5 columnas con dos botones a la derecha -->
  <app-module-summary-bar [autoLoadDashboard]="true"
    [showPersonalStats]="tipoMenu === 'megamenu2' || usuario.role === 'ADMIN_ROLE' || usuario.role === 'SALESMAN_ROLE' || usuario.role === 'IT_ROLE'"
    [primaryLabel]="'Add Business'" [secondaryLabel]="'Export List'"
    [showPrimary]="canCreateCustomer" [disabledPrimary]="loading()"
    [disabledSecondary]="loading()" [loadingSecondary]="exporting" (primaryClick)="onSummaryPrimary()" (secondaryClick)="onSummarySecondary()">
  </app-module-summary-bar>

  <div class="flex flex-col xl:flex-row xl:items-center gap-2 mb-2 px-1 w-full xl:justify-between">
    <div class="w-full xl:flex-1 xl:min-w-0 xl:max-w-2xl">
      <app-search-input [placeholder]="'Business ID, Name, Address …'" (searchChange)="onTabletSearch($event)">
      </app-search-input>
    </div>

    <div class="flex flex-row items-center justify-between xl:justify-end gap-2 w-full xl:w-auto flex-wrap">
      @if (tipoMenu === 'megamenu2') {
        <button
          type="button"
          class="tank-check-toggle-btn shrink-0"
          [class.active]="onlyWithSensors()"
          (click)="onToggleSensors()"
          title="Filter only businesses with HazTracker IoT sensors">
          <i class="fa fa-wifi"></i>
          <span>Tank Check</span>
          @if (tankSummary() && tankSummary()!.linked > 0) {
            @if (tankSummary()!.critical_count > 0) {
              <span class="tank-traffic-pill critical" title="{{ tankSummary()!.critical_count }} tanks >= 80% needing collection">
                <span class="traffic-dot"></span>{{ tankSummary()!.critical_count }} Critical
              </span>
            }
            @if ((tankSummary()!.normal_count ?? (tankSummary()!.linked - tankSummary()!.critical_count)) > 0) {
              <span class="tank-traffic-pill healthy" title="{{ (tankSummary()!.normal_count ?? (tankSummary()!.linked - tankSummary()!.critical_count)) }} tanks normal (<80%)">
                <span class="traffic-dot"></span>{{ (tankSummary()!.normal_count ?? (tankSummary()!.linked - tankSummary()!.critical_count)) }} Normal
              </span>
            }
          }
          @if (onlyWithSensors()) {
            <span class="tank-check-badge">Active</span>
          }
        </button>
      }

      <div class="flex flex-row gap-2 items-center shrink-0">
        <app-tablet-date-filter (filterChange)="onDateFilter($event)" class="shrink-0">
        </app-tablet-date-filter>

        <app-tablet-status-filter [options]="filter_options" [selectedValues]="selected_values"
          (valuesChange)="onStatusFilter($event)" class="shrink-0">
        </app-tablet-status-filter>
      </div>
    </div>
  </div>

  <!-- GRID (CUSTOMERS LIST) -->
  <div class="row animated fadeIn mt-1">
    <div class="col-12">
      <div class="card p-0">
        <div class="card-body bg-white p-0">
          <div class="row">
            <div class="col">
              <app-kite-grid
                [columnDefs]="columnDefs"
                [rowData]="clients()"
                [loading]="loading()"
                [gridOptions]="gridOptions"
                [totalRecords]="totalRecords"
                [pageSize]="pageSize"
                [tipoMenu]="tipoMenu"
                (pageChange)="onPageChange($event)">
              </app-kite-grid>
            </div>
          </div>
        </div>
      </div>
    </div>
  </div>
</div>

<!-- =========================================================
  MODALS
========================================================= -->

<!-- Crear Cliente SELECT - Modal -->
<ng-template #clienteSelectModal let-modal class="animated fadeIn">
  <div class="modal-header btn-themecolor dialog-title">
    <h4 class="modal-title text-white" id=" modalLabel">NEW RESTAURANT NAME</h4>
    <button type="button " class="btn-close" aria-label="Close " (click)="modal.dismiss('Cross click')"></button>
  </div>

  <div class="kite-modal-body p-4">
    <form [formGroup]="visitPlanModalForm" (ngSubmit)="newBestDate()" autocomplete="off" ngNativeValidate>
      <div class="row">
        <div class="col-md-12 mb-3">
          <div class="row g-3 align-items-center">
            <div class="col-auto">
              <label for="inputPassword6" class="label">Name</label>
            </div>
            <div class="col-6">
              <div class="input-group input-group-sm">
                <input type="datetime-local" class="form-control" id="best-date" name="best_date"
                  formControlName="best_date" />
              </div>
            </div>
          </div>
        </div>
      </div>

      <div class="row">
        <div class="col"></div>
        <div class="col-5">
          <app-custom-button type="submit"> Add Date </app-custom-button>
        </div>
      </div>
    </form>

    <h5 class="mt-3">VISIT LIST</h5>

    <div class="row">
      <div class="col-12">
        <table class="table">
          <thead class="bg-light">
            <tr class="text-center">
              <th class="border border-secondary" scope="col">DATES & TIME</th>
              <th class="border border-secondary w300" scope="col">NOTE</th>
            </tr>
          </thead>
          <tbody class="border border-secondary" *ngFor="let item of visitPlan_arr; let i = index">
            <tr>
              <td class="border border-secondary text-center">
                {{ item.dateTime | date : "medium" }}
              </td>
              <td class="border border-secondary w300">
                <div class="d-flex justify-content-between">
                  <input type="text" class="form-control mr-2" id="visitnote" name="visit_note" [(ngModel)]="item.note"
                    toUppercase />
                  <button type="button" class="btn btn-link p-0 text-inverse" data-toggle="tooltip" data-original-title="Delete" title="Delete note" aria-label="Delete note">
                    <i class="fa fa-edit text-inverse mt-2" aria-hidden="true"></i>
                  </button>
                </div>
              </td>
            </tr>
          </tbody>
        </table>
      </div>
    </div>
  </div>

  <div class="modal-footer mx-auto">
    <button type="button" class="btn btn-block kite-button" (click)="newVisitPlan(modal)">
      Save & Close
    </button>
  </div>
</ng-template>

<!-- Visit PLAN - Modal -->
<ng-template #visitPlanModal let-modal class="animated fadeIn">
  <div class="modal-header btn-themecolor dialog-title">
    <h4 class="modal-title text-white" id=" modalLabel">MEETING PLAN</h4>
    <button type="button " class="btn-close" aria-label="Close " (click)="modal.dismiss('Cross click')"></button>
  </div>

  <div class="kite-modal-body p-4" style="
      border-radius: 15px !important;
      padding-top: 2.25rem !important;
      padding-right: 2.25rem !important;
      padding-left: 2.25rem !important;
      padding-bottom: 0px !important;
    ">
    <form [formGroup]="visitPlanModalForm" (ngSubmit)="newBestDate()" autocomplete="off" ngNativeValidate>
      <div class="row kite-vpborder" style="margin-bottom: 1rem">
        <div class="col-md-12 mb-3">
          <div class="row g-3 align-items-center">
            <div class="col-auto">
              <label for="inputPassword6" class="label">SCHEDULE VISIT</label>
            </div>
            <div class="col-md-8">
              <small *ngIf="vpBestDateNoValido" class="animated fadeIn text-danger">
                *Date Required
              </small>
              <div class="input-group input-group-sm">
                <input type="datetime-local" class="form-control kite-imput" id="best-date" name="best_date"
                  formControlName="best_date" [class.is-invalid]="vpBestDateNoValido" />
              </div>
            </div>
          </div>
        </div>

        <div>
          <app-custom-button type="submit" style="margin-bottom: 1rem">
            Add Date
          </app-custom-button>

          <!-- DISABLED: Legacy submit button (replaced by custom button above). -->
          <!--
          <button
            type="submit"
            class="btn btn-themecolor btn-block kite-button"
            style="margin-bottom: 1rem"
          >
            Add Date
          </button>
          -->
        </div>
      </div>
    </form>

    <div class="row">
      <div class="col-md-12">
        <table class="table">
          <thead class="kite-tb-header">
            <tr class="text-center">
              <th class="border" scope="col">DATES & TIME</th>
              <th class="border w300" scope="col">NOTE</th>
            </tr>
          </thead>
          <tbody class="border border-secondary" *ngFor="let item of visitPlan_arr; let i = index">
            <tr>
              <td class="border text-center">
                {{ item.dateTime | date : "medium" }}
              </td>
              <td class="border w300">
                <div class="d-flex justify-content-between">
                  <input type="text" class="form-control mr-2" id="visitnote" name="visit_note" [(ngModel)]="item.note"
                    toUppercase />
                  <button type="button" class="btn btn-link p-0 text-inverse" data-toggle="tooltip" data-original-title="Delete" title="Delete note" aria-label="Delete note">
                    <i class="fa fa-edit text-inverse mt-2" aria-hidden="true"></i>
                  </button>
                </div>
              </td>
            </tr>
          </tbody>
        </table>
      </div>
    </div>
  </div>

  <div class="modal-footer mx-auto">
    <button type="button" class="btn btn-themecolor kite-button" (click)="newVisitPlan(modal)"
      *ngIf="visitPlan_arr.length > 0">
      SAVE PLAN
    </button>
  </div>
</ng-template>

<!-- MODAL INFO -->
<ng-template #infoModal let-modal>
  <div>
    <div class="modal-header" style="background-color: var(--color-brand-main, #2e5ea8)">
      <h4 class="modal-title text-white" id=" modalInfotitle ">
        CUSTOMER INFORMATION
      </h4>
    </div>

    <div class="modal-body">
      <div style="margin: 2% !important">
        <div class="row kite-border-head">
          <div class="col-lg-3 col-md-3">
            <label class="label">CLIENT ID</label>
            <p class="kite-info-id">{{ client.ident_GUI | uppercase }}</p>
          </div>
          <div class="col-lg-9 col-md-9">
            <label class="label">CLIENT NAME</label>
            <p class="kite-info-p">{{ client.name_client | uppercase }}</p>
          </div>
          <div class="col-lg-8 col-md-9">
            <label class="label">CLIENT ADDRESS</label>
            <p class="kite-info-p">
              {{ client.address || "undefined" | uppercase }}
            </p>
          </div>
          <div class="col-lg-4 col-md-3">
            <label class="label">STATUS</label>
            <p class="kite-duedate">
              {{ client.status || "undefined" | uppercase }}
            </p>
          </div>
          <div class="col-lg-4 col-md-5">
            <label class="label">CITY</label>
            <p class="kite-info-p">{{ client.city | uppercase }}</p>
          </div>
          <div class="col-lg-4 col-md-3">
            <label class="label">ZIP CODE</label>
            <p class="kite-info-p">
              {{ client.zip_code || "undefined" | uppercase }}
            </p>
          </div>
          <div class="col-lg-4 col-md-4">
            <label class="label">CREATE</label>
            <p class="kite-duedate">
              {{ client.month }} / {{ client.day }} /
              {{ client.year || "undefined" | uppercase }}
            </p>
          </div>
        </div>
      </div>

      <div>
        <div class="row">
          <div class="col-lg-5 col-md-5">
            <label class="label">CLIENT CONTACT</label>
            <p class="kite-status">
              {{ client.contact_name || "undefined" | uppercase }}
            </p>
          </div>
          <div class="col-lg-3 col-md-3">
            <label class="label">PHONE NUMBER</label>
            <p class="kite-status">
              {{ client.phone || "undefined" | uppercase }}
            </p>
          </div>
          <div class="col-lg-4 col-md-4">
            <label class="label">BUSINESS TYPE</label>
            <p class="kite-status">
              {{ client.business_type || "undefined" | uppercase }}
            </p>
          </div>
          <div class="col-lg-7 col-md-8">
            <label class="label">EMAIL</label>
            <p class="kite-status">
              {{ client.email || "undefined" | uppercase }}
            </p>
          </div>
          <div class="col-lg-5 col-md-4">
            <label class="label">SALES PERSON</label>
            <p class="kite-status">{{ client.sales_person | uppercase }}</p>
          </div>
        </div>
      </div>

      <div class="modal-footer" style="border-top: 1px solid #ececec; justify-content: center !important;">
        <div class="col text-center">
          <button type="button" class="btn kite-btn-close" data-dismiss="modal" (click)="modal.dismiss('close')">
            Close
          </button>
        </div>
      </div>
    </div>
  </div>
</ng-template>